"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _HotSpotBox = _interopRequireDefault(require("../Models/HotSpotBox"));
var _ItemPipes = _interopRequireDefault(require("./ItemPipes"));
var _Device = _interopRequireDefault(require("../Models/Device"));
var _useGetComponentsByParams = require("../../../hooks/store/useGetComponentsByParams");
var _models = require("../../models");
var _constants = require("../../../utils/constants");
const _excluded = ["equipmentId", "position"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const {
  ComponentTypes,
  LoopType,
  SectionTypes,
  sensorTypes
} = _paulCorePackage.constants;
const Item = props => {
  const {
      equipmentId = null,
      position = [0, 0, 0]
    } = props,
    p = _objectWithoutProperties(props, _excluded);
  const type = ComponentTypes.PwcPoe;
  const PwcPoe = (0, _useGetComponentsByParams.useGetComponentByTypeAndId)({
    type,
    id: equipmentId
  }) || {};
  const hasBackFlushFilter = Boolean(PwcPoe.thingPOEBackflushFilterPresent);
  const showBox = false;
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("group", _extends({
    position: position
  }, p), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 10, 50],
    args: [3, 7, 15],
    showBox: showBox
  }, /*#__PURE__*/_react.default.createElement(_models.PointOfEntryModel, {
    position: [0, 0, 0]
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 10, 35],
    args: [4, 19, 7],
    showBox: showBox
  }, hasBackFlushFilter ? /*#__PURE__*/_react.default.createElement(_models.SmartBackWashFilterModel, {
    position: [0, 0, 0],
    color: "#59A5C6"
  }) : /*#__PURE__*/_react.default.createElement(_models.BackWashFilterModel, {
    position: [0, 0, 0]
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 10, 22.5],
    showBox: showBox,
    pipe: _constants.pipesTypes.chilledWater
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentId: equipmentId,
    equipmentType: type,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.none,
    cardPosition: [1, 10, -6.5],
    requiredTypeNot: sensorTypes.backflushFilter,
    modelProps: {
      [sensorTypes.smartValve]: {
        deviceRotate: [-Math.PI / 2, -Math.PI / 2, 0]
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_ItemPipes.default, null)), [position, p, hasBackFlushFilter]);
};
var _default = exports.default = Item;